import ArrowBase from "./ArrowBase";

const ArrowDown = ArrowBase.extend`
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid black;
`;

export default ArrowDown;
